import request from '../request'

export const interviewQuestionApi = {
  listInterviewQuestion (params) {
    return request.get('/v2/admin/interviewQuestions', { params: params })
  },
  getInterviewQuestion (id) {
    return request.get('/v2/admin/interviewQuestions/' + id)
  },
  saveInterviewQuestion (data) {
    return request.post('/v2/admin/interviewQuestions', data)
  },
  updateInterviewQuestion (id, data) {
    return request.put('/v2/admin/interviewQuestions/' + id, data)
  },
  deleteInterviewQuestion (id) {
    return request.delete('/v2/admin/interviewQuestions/' + id)
  },
}

export default interviewQuestionApi
